import { useMemo } from "react";

const InlineText = ({ text }) => {
  const parts = text.replace(/\*\*/g, "").split(/(\[S\d+\])/g);
  return parts.map((part, index) => {
    if (/^\[S\d+\]$/.test(part)) {
      const ref = part.slice(1, -1);
      return (
        <a key={`${ref}-${index}`} href={`#source-${ref}`} className="font-semibold text-orange-700 hover:underline">
          {part}
        </a>
      );
    }
    return <span key={index}>{part.replace(/\*/g, "")}</span>;
  });
};

export const DraftPreview = ({ markdown }) => {
  const lines = useMemo(() => (markdown || "").split("\n"), [markdown]);
  return (
    <article className="max-w-none text-slate-700 leading-7" data-testid="research-draft-preview">
      {lines.map((line, index) => {
        const trimmed = line.trim();
        if (!trimmed) return <div key={index} className="h-3" />;
        if (trimmed.startsWith("### ")) {
          return <h3 key={index} className="text-xl font-semibold text-slate-900 mt-7 mb-2"><InlineText text={trimmed.slice(4)} /></h3>;
        }
        if (trimmed.startsWith("## ")) {
          return <h2 key={index} className="text-2xl font-semibold text-slate-900 mt-9 mb-3 border-b border-slate-100 pb-2"><InlineText text={trimmed.slice(3)} /></h2>;
        }
        if (trimmed.startsWith("# ")) {
          return <h1 key={index} className="text-3xl sm:text-4xl font-semibold text-slate-950 mb-5"><InlineText text={trimmed.slice(2)} /></h1>;
        }
        if (trimmed.startsWith("- ")) {
          return <div key={index} className="flex gap-3 ml-2"><span className="text-orange-500">•</span><p><InlineText text={trimmed.slice(2)} /></p></div>;
        }
        return <p key={index} className="mb-3"><InlineText text={trimmed} /></p>;
      })}
    </article>
  );
};

export default DraftPreview;
